/* global InitialData URLs */

import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';

import 'topmeteo/utils/legacy';
import {createStore} from 'topmeteo/utils/redux';

import {TypeLoc} from 'topmeteo/general/constants';
import {dataReloaded} from 'topmeteo/general/actionCreators';

import UserDefaults from 'topmeteo/general/components/UserDefaults';
import KeyboardControl from 'topmeteo/general/components/KeyboardControl';
import TestNotifications from 'topmeteo/general/components/TestNotifications';

import {buildURL} from './url';
import reducer from './reducer';
import {changeRegion, popState} from './actionCreators';

import ControlsArea from './components/ControlsArea';
import URLChanger from './components/URLChanger';

const ControlsAreaNode = document.getElementById('controls-area');
const CSRFMiddlewareNode = ControlsAreaNode.getElementsByTagName('input')[0];
const CSRFMiddlewareToken = CSRFMiddlewareNode.value;

const store = createStore(reducer, 'Location Forecast');

store.dispatch(dataReloaded({...InitialData, ...URLs, CSRFMiddlewareToken, type: TypeLoc, isInitial: true}));

render(
    <Provider store={store}>
        <URLChanger popState={popState} buildURL={buildURL}>
            <UserDefaults>
                <TestNotifications />
                <KeyboardControl type={TypeLoc} />
                <ControlsArea changeRegion={changeRegion} />
            </UserDefaults>
        </URLChanger>
    </Provider>,
    ControlsAreaNode,
);
